// extracted by mini-css-extract-plugin
export default {"areaBox":"style_areaBox__qg4EI"};